import { addToCart } from "./cart.js";

const selectors = {
  addCartBtn: ".js-product-card-atc",
};

const classes = {
  loading: "loading",
};

class ProductCard extends HTMLElement {
  constructor() {
    super();
    this.handleAddCart = this.handleAddCart.bind(this);
  }

  connectedCallback() {
    this.addCartBtn = this.querySelector(selectors.addCartBtn);
    if (!this.addCartBtn) return;
    this.addCartBtn.addEventListener("click", this.handleAddCart);
  }

  disconnectedCallback() {
    if (this.addCartBtn) {
      this.addCartBtn.removeEventListener("click", this.handleAddCart);
    }
  }

  async handleAddCart(e) {
    e.preventDefault();
    e.stopPropagation();

    let productData;
    try {
      productData = JSON.parse(this.getAttribute("data-product"));
    } catch {
      return;
    }
    if (!productData || !productData.id) return;

    const formData = new FormData();
    Object.entries(productData).forEach(([key, value]) => formData.append(key, value));

    this.addCartBtn.disabled = true;
    this.addCartBtn.classList.add(classes.loading);

    try {
      await addToCart(formData);
    } catch (error) {
      console.error("Failed to add to cart:", error);
      alert("Failed to add item to cart. Please try again.");
    } finally {
      const btn = this.querySelector(selectors.addCartBtn);
      if (btn) {
        btn.disabled = false;
        btn.classList.remove(classes.loading);
      }
    }
  }
}

if (!customElements.get("product-card")) {
  customElements.define("product-card", ProductCard);
}
